import { MapSlots, SetMapArgs, SetMapSlot } from 'components/map/slots/slots-main.js';
import { createContext } from 'react';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { IMapV2 } from 'types/location.js';

const defaultValue = {
  mapSlot: undefined,
  setMapSlot: (_: Partial<SetMapArgs> | undefined) => 0,
};
interface MapSlotContextProps {
  mapSlot: IModuleConfig[] | undefined;
  setMapSlot: SetMapSlot;
}

export const MapSlotContext = createContext<MapSlotContextProps>(defaultValue);

export const MapSlotProvider = ({ children, mapConfig }: { children: JSX.Element; mapConfig: IMapV2 | undefined }) => {
  const [mapSlot, setMapSlot] = MapSlots({ mapConfig });

  return (
    <MapSlotContext.Provider
      value={{
        mapSlot,
        setMapSlot,
      }}
    >
      {children}
    </MapSlotContext.Provider>
  );
};
